// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"bfa2a8d8","818":"d30671c2"}[chunkId] + ".chunk.js";
};